import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMarketer } from '@/shared/model/marketer.model';
import { IRestaurant } from '@/shared/model/restaurant.model';

const baseApiUrl = 'api/marketers';
const baseAdminApiUrl = 'api/admin';

export default class MarketerService {
  public find(id: number): Promise<IMarketer> {
    return new Promise<IMarketer>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public checkMarketer(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/check/${id}`)
        .then(res => {
          resolve(true);
        })
        .catch(err => {
          reject(false);
        });
    });
  }

  public findByUserId(id: number): Promise<IMarketer> {
    return new Promise<IMarketer>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/user/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findModerator(link: string): Promise<number> {
    return new Promise<number>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/id/${link}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getMarketerLink(id: string): Promise<IMarketer> {
    return new Promise<IMarketer>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/link/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getSubMarketers(id: string): Promise<IMarketer[]> {
    return new Promise<IMarketer[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/submarketers/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getRestaurants(id: string): Promise<IRestaurant[]> {
    return new Promise<IRestaurant[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/restaurants/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveMarketers(req?: any): Promise<any> {
    return axios.get(`api/support/marketers?${buildPaginationQueryOpts(req)}`);
  }

  public retrieveNewMarketers(req?: any): Promise<any> {
    return axios.get(`api/support/newMarketers?${buildPaginationQueryOpts(req)}`);
  }

  public retrieveUnregisteredMarketers(): Promise<any> {
    return axios.get(`api/support/users/marketers`);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public deleteMarketer(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseAdminApiUrl}/delete-marketer/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IMarketer): Promise<IMarketer> {
    return new Promise<IMarketer>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IMarketer): Promise<IMarketer> {
    return new Promise<IMarketer>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public setMarketerApproval(marketerId: number, decision: boolean): Promise<IMarketer> {
    return new Promise<IMarketer>((resolve, reject) => {
      axios
        .patch('api/support/marketer/approval/' + marketerId, decision, {
          headers: { 'content-type': 'application/merge-patch+json' },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public setMarketerActivation(marketerId: number, decision: boolean): Promise<IMarketer> {
    return new Promise<IMarketer>((resolve, reject) => {
      axios
        .patch('api/support/marketer/activation/' + marketerId, decision, {
          headers: { 'content-type': 'application/merge-patch+json' },
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
